import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.dealer-franchisee.pages.AppQuotePage.';
  public static readonly supplierOfflineMsg = `${Id.prefix}supplierOfflineMsg`;
  public static readonly supplierOffline = `${Id.prefix}supplierOffline`;
  public static readonly quoteGlossary = `${Id.prefix}quoteGlossary`;
  public static readonly quoteEditorTitle = `${Id.prefix}quoteEditorTitle`;
  public static readonly quoteEditorCopying = `${Id.prefix}quoteEditorCopying`;
  public static readonly quoteEditorDeleting = `${Id.prefix}quoteEditorDeleting`;
}

export class LangAppQuotePage {
  private constructor() {}
  public static supplierOfflineMsg(): string {
    return interpolate(Id.supplierOfflineMsg);
  }
  public static cannotOpenWhileCopying(): string {
    return interpolate(Id.quoteEditorCopying);
  }
  public static cannotOpenWhileDeleting(): string {
    return interpolate(Id.quoteEditorDeleting);
  }
  public static supplierOffline(): string {
    return interpolate(Id.supplierOffline);
  }
  public static quoteGlossary(): string {
    return interpolate(Id.quoteGlossary);
  }
  public static quoteEditorTitle(params: { quoteTitle: string }): string {
    return interpolate(Id.quoteEditorTitle, params);
  }
}

export class AppQuotePageModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(
      Id.supplierOfflineMsg,
      "{{glossary 'supplier'}} service is OFFLINE. because of this, you will be restricted to readonly mode at this time. Please contact support if this problem is not resolved shortly.",
      'Message shown when supplier service is offline and user is restricted to readonly mode'
    );
    register.add(Id.supplierOffline, "{{glossary 'supplier'}} OFFLINE", 'Short message shown when supplier is offline');
    register.add(Id.quoteGlossary, "{{glossary 'quote'}}", 'Glossary term for quote (singular)');
    register.add(
      Id.quoteEditorTitle,
      "{{glossary 'quote'}} Editor {{quoteTitle}}",
      'Title for the quote editor page, with quote title'
    );
    register.add(
      Id.quoteEditorCopying,
      "Cannot open {{glossary 'quote'}} while it is being copied.",
      'Message shown when user attempts to open a quote that is currently being copied'
    );
    register.add(
      Id.quoteEditorDeleting,
      "Cannot open {{glossary 'quote'}} while it is being deleted.",
      'Message shown when user attempts to open a quote that is currently being deleted'
    );
  }
}
